import { render, staticRenderFns } from "./SpecialistBookingDetail.vue?vue&type=template&id=6b14e557"
import script from "./SpecialistBookingDetail.vue?vue&type=script&lang=js"
export * from "./SpecialistBookingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports